/* eslint-disable max-len */
export const getApproveDvDContent = (t, params) => {
  const {
    values: { quantityToSend, recipient, quantityToReceive, symbolToReceive },
    token,
    sender,
    investor,
  } = params;

  return `
  <div class="_m:y(2)" style="display: flex; flex-wrap: wrap; max-width: 45rem;">


        ${t('shared.youWill')} ${t('shared.send').toLocaleLowerCase()}

        <strong class="_m:x(1)">${quantityToSend} ${token.symbol}</strong>

        ${
          sender.provider === 'ONCHAINID'
            ? t('shared.fromYourOnchainidWallet')
            : t('shared.fromYourWallet')
        }:

        <ds-explorer-link network=${token.blockchainNetwork} address=${
    sender.wallet
  }  is-copyable=${false}></ds-explorer-link>

        ${t('shared.toTheWallet')}:
        
        <ds-explorer-link network=${
          token.blockchainNetwork
        } address=${recipient} class="_m:top(1)" is-copyable=${false}></ds-explorer-link>

        
        <span class="_text-grey-900 _m:x(2)">( <ds-eth-avatar class="_m:right(2)" size="12px" address=${recipient}></ds-eth-avatar> ${investor} ) </span>


        ${' ' + t('shared.and')} ${t('shared.receive')}

        <strong class="_m:x(1)">${quantityToReceive} ${symbolToReceive}</strong> 
        
        ${t('shared.toYourWallet')}, 

        <strong class="_m:left(1)">${t('shared.ifCounterpartInvestorApproves')}.</strong>

      <div class="_flex:align(center) _m:y(2)" style="width: 100%;">
        ${t('shared.doYouWantToProceed')}
      </div>
    </div>`;
};

export const getApproveDirectContent = (t, values) => {
  const { tokenQuantity, symbol, sender, recipient, investor, token } = values;

  return `
      <div class="_m:y(2)" style="display: flex; flex-wrap: wrap; max-width: 45rem;">

        ${t('shared.youAreAboutToSend')}
  
        <strong class="_m:x(1)">${tokenQuantity} ${symbol}</strong>
      
        ${t('shared.fromYourWallet')}:
    
        <ds-explorer-link network=${
          token.blockchainNetwork
        } address=${sender} class="_m:x(2)" is-copyable=${false}></ds-explorer-link>
  
        ${t('shared.toTheWallet')}:

        <ds-explorer-link network=${
          token.blockchainNetwork
        } address=${recipient} class="_m:x(2)" is-copyable=${false}></ds-explorer-link>

        <span class="_text-grey-900">( <ds-eth-avatar class="_m:right(2)" size="12px" address=${recipient}></ds-eth-avatar> ${investor} ).</span>
 
        <div class="_flex:align(center) _m:y(2)" style="width: 100%;"> 
          ${t('shared.doYouWantToProceed')}
        </div>

      </div>
      `;
};
